import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { DepositETHTransaction } from '../../store/deposit/types'
import { useWeb3Address } from '../../store/web3/hooks'
import { useUserAuthConnected } from '../../store/account/hooks'
import { useMemo } from 'react'
import { Equal } from '../../utils/equal'
import { NetworkRegistry } from '../../utils/networkRegistry'
import { ChainType } from '../../constants/chains'
import dayjs from 'dayjs'
import { DEPOSIT_PENDING_TRANSACTION_TIMEOUT } from '../../constants/deposit'

export function useUnexpiredDepositPendingTxs() {
  const transactions = useSelector<RootState, DepositETHTransaction[]>(
    (state) => state.deposit.pendingTxs,
  )
  const address = useWeb3Address()
  const userAuthConnected = useUserAuthConnected()
  return useMemo(() => {
    if (!address || !userAuthConnected) {
      return []
    }
    // Filter owner transactions
    // And filter EVM transactions
    const ownerTransactions = transactions
      ?.filter((item) => Equal.address(address, item.fromAddress))
      ?.filter(
        (v) => NetworkRegistry.chainType(v.layerOneChainId) === ChainType.Evm,
      )
    // Filter unexpired transactions
    const now = new Date().getTime()

    return ownerTransactions?.filter(
      (item) =>
        now - dayjs(item.createdAt).valueOf() <=
        DEPOSIT_PENDING_TRANSACTION_TIMEOUT,
    )
  }, [transactions, address, userAuthConnected])
}
